import React from 'react'
import { CFView, DefaultScreen, MobileScreen } from 'components'
import { contactbg, mobileContactbg } from 'images'
import RestaurantDetails from './RestaurantDetails'
import Hours from './Hours'
import Map from './Map'
import SocialMedia from './SocialMedia'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView column center>
          <Map />
          <CFView
            column
            center
            w="100%"
            image={`url(${mobileContactbg}) center / cover no-repeat`}
          >
            <CFView pv="20px" w="100%" column center>
              <RestaurantDetails />
              <SocialMedia />
              <Hours />
            </CFView>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView column center>
          <Map />
          <CFView
            w="100%"
            pv="50px"
            row
            alignCenter
            justifyAround
            image={`url(${contactbg}) center / cover no-repeat`}
          >
            <CFView ml="200px" w="100%" row justifyAround maxWidth="700px">
              <CFView column>
                <RestaurantDetails />
                <SocialMedia />
              </CFView>
              <Hours />
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
